import { ModelBase, Property, Required, ShortString } from '@skylab-shared/core';

export class AdjustmentReasonModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    public default: boolean;

    @Property()
    @ShortString('data-model.adjustment-reason.validation.name.length')
    @Required('data-model.adjustment-reason.validation.name.non-empty')
    public name: string;
}
